import {
    Button,
    Center,
    Container,
    Grid,
    Heading,
    HStack,
    Table,
    TableContainer,
    Tag,
    TagLabel,
    Tbody,
    Td,
    Th,
    Thead,
    Tr
} from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../redux/storage';
import LoadingPage from '../LoadingPage';
import { useEffect } from 'react';
import { fetchUsers } from '../../redux/features/userListSlice';
import { useNavigate } from 'react-router-dom';
import MenuNavbar from '../../components/ui/Menu';
import usePageTitle from '../../utils/pageTitle';

const UserList = () => {

    const dispatch = useDispatch<AppDispatch>();
    const states = useSelector((state: any) => state.userList)
    const navigate = useNavigate()

    usePageTitle("Lista Usuarios")


    useEffect(() => {
        dispatch(fetchUsers())
    }, [])


    return (
        <Grid minHeight="100vh">

            <MenuNavbar />

            <Container maxW='5xl' mt={-300}>
                {states.loading ? <LoadingPage /> :
                    <TableContainer>
                        <Heading size='md' mb={5}>
                            <Center>
                                Listado de usuarios
                            </Center>
                        </Heading>

                        <Button colorScheme="brand" variant='solid' onClick={() => navigate('/user/create')}>
                            Agregar usuario
                        </Button>

                        <Table variant='simple' mt={5}>
                            <Thead>
                                <Tr>
                                    <Th>Id</Th>
                                    <Th>Correo</Th>
                                    <Th>Nombre</Th>
                                    <Th>Estado</Th>
                                    <Th>Roles</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {!states.loading && states.users.length > 0 ?
                                    states.users.map((u: any) =>
                                        <Tr key={u.id}>
                                            <Td>{u.id}</Td>
                                            <Td>{u.email}</Td>
                                            <Td>{u.name}</Td>
                                            <Td>
                                                <Tag colorScheme={u.active ? 'green' : 'red'}>
                                                    {u.active ?
                                                        'Activo' :
                                                        'Inactivo'
                                                    }
                                                </Tag>
                                            </Td>
                                            <HStack mt={7}>
                                                {u.roles?.map((r: any) =>
                                                    <Tag
                                                        key={`${r.rol.code}-${u.id}`}
                                                        borderRadius='full'
                                                        variant='solid'
                                                        colorScheme='brand'>
                                                        <TagLabel>{r.rol.description}</TagLabel>
                                                    </Tag>
                                                )
                                                }
                                            </HStack>
                                        </Tr>)
                                    :
                                    <Tr>
                                        <Td>No se encontraron resultados</Td>
                                    </Tr>
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                }
            </Container>
        </Grid>
    );
}

export default UserList;
